module.exports = __webpack_public_path__ + "static/media/37.d3fceb2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/newWeatherIcons/37.svg
// module id = 2828
// module chunks = 3